import type { BillingPlan, BillingPlanSummary, BillingPlanView, CreateBillingPlan } from '../billing/billing.interface';
import { baseDocumentFactory } from './base-document.factory';
import { ObjectFactory } from './object.factory';

export class BillingPlanFactory extends ObjectFactory<BillingPlan> {
  protected getDefaults(): BillingPlan {
    return {
      ...baseDocumentFactory.build(),
      configuration: {
        constraints: { vehicleMaxCount: 20 },
        fees: { monthlyFee: 99, monthlyVehicleFee: 5, taskFee: 0.5 },
        limits: { monthlyPriceCap: 5000 },
      },
      currency: 'EUR',
      name: 'standard',
    };
  }

  buildCreate(overrides: Partial<CreateBillingPlan> = {}): CreateBillingPlan {
    const { configuration, currency, name } = this.build(overrides);
    return { configuration, currency, name };
  }

  /** Immutable creation-time snapshot shape embedded into a `TenantBillingConfiguration`. */
  buildSummary(overrides: Partial<BillingPlanSummary> = {}): BillingPlanSummary {
    const { configuration, currency, id, name } = this.build(overrides);
    return { configuration, currency, id, name };
  }

  /** Adds the computed `inUse` flag (defaults to `false`) on top of `build()`. */
  buildView(overrides: Partial<BillingPlanView> = {}): BillingPlanView {
    const { inUse = false, ...rest } = overrides;
    return { ...this.build(rest), inUse };
  }
}

export const billingPlanFactory = new BillingPlanFactory();
